import { defer } from "react-router-dom";
import { fetchInvoices } from "redux/slices/invoice";
import store from "redux/store";

export const dashboardLoader = async () => {
  const fetchInvoicesPromise = store.dispatch(fetchInvoices());
  return defer({ fetchInvoicesPromise });
};

export const shouldRevalidateDashboard = () => false;
